var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect2, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.84,95.18l-292.79,82c20.47-13,43.19-23.16,65.8-33.22,24.56-10.93,42.39-6.49,69.49-10.57,12.48-1.89,33.34-14.93,43.72-21.3,18.7-11.47,37.59-23.64,58.65-22.13,4.74-8.28,14.9-14.23,25.59-15s21.51,3.68,27.25,11.2c0,0,17.67-4.63,24.64-1.16l20.52-.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35,123.36c32-20.73,58.18-17.81,88.68-31.3a241.63,241.63,0,0,0,24-12.75C202,70,218.8,60.11,237.75,59a298.42,298.42,0,0,1,44.51-8.55c22-2.51,44.23-2.6,66.26-4.84C272.61,58.42,145.75,98.88,73.35,123.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.6,
    cy: 467.1,
    rx: 41.94,
    ry: 8.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.04,
    cy: 361.16,
    rx: 41.94,
    ry: 8.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.49,401.81l-12,9.06c125.88,41.08,265,40.38,390.46-2C314.72,410,188.35,411,62.49,401.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.46,144.54a21.49,21.49,0,0,1,3.09-5.47,9.12,9.12,0,0,1,5.82-3.23c2.36-.25,5,.84,5.74,2.76.34-4.33,1.06-8.77,3.6-12.53a13.67,13.67,0,0,1,23.5.44c2.28,3.6,3.06,2.45,3.8,6.49,1.82-1.9,5.65-1.31,7.54.54s2.37,4.41,2.77,6.84l-58.66,5.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,230.13a21.32,21.32,0,0,1,3.09-5.47,9.07,9.07,0,0,1,5.81-3.23c2.37-.25,5,.84,5.75,2.76.34-4.33,1.06-8.77,3.6-12.53a14.52,14.52,0,0,1,12.34-6.45,14.53,14.53,0,0,1,11.16,6.89c2.27,3.6,3.06,2.44,3.8,6.49,1.82-1.9,5.64-1.31,7.54.54s2.37,4.41,2.77,6.84l-58.66,5.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.34,70.94a16.65,16.65,0,0,1,3.09-4.43,9.75,9.75,0,0,1,5.81-2.62c2.36-.2,5,.68,5.75,2.24.34-3.52,1.06-7.12,3.59-10.17a15.7,15.7,0,0,1,12.35-5.23,15.21,15.21,0,0,1,11.16,5.58c2.27,2.93,3,2,3.8,5.27,1.81-1.54,5.64-1.06,7.53.44s2.38,3.58,2.78,5.55L79.54,71.86Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.94,465c0,.14-12.29.26-27.45.26S161,465.12,161,465s12.29-.26,27.45-.26S215.94,464.83,215.94,465Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,471.09c0,.15-11.11.26-24.8.26s-24.8-.11-24.8-.26,11.1-.26,24.8-.26S231.12,471,231.12,471.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,453.05c0,.14-8.65.26-19.31.26s-19.32-.12-19.32-.26,8.65-.26,19.32-.26S410,452.9,410,453.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.48,458.35c0,.15-7.81.26-17.44.26s-17.45-.11-17.45-.26,7.81-.26,17.45-.26S425.48,458.21,425.48,458.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.32,447.94c0,.15-7.81.26-17.45.26s-17.45-.11-17.45-.26,7.81-.26,17.45-.26S421.32,447.8,421.32,447.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.47,344.31c0,.15-105.88.26-236.46.26s-236.48-.11-236.48-.26,105.86-.26,236.48-.26S486.47,344.17,486.47,344.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Islands--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.94,358.25c0,3.75-17.36,6.8-38.76,6.8s-38.77-3.05-38.77-6.8c0-.47.1-3.74.1-3.74,3.58-3.1,19.9-3.07,38.67-3.07,18.56,0,35-.87,38.69,3.15C475.94,354.67,475.94,357.75,475.94,358.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.94,354.4c0,3.42-17.36,6.19-38.76,6.19s-38.77-2.77-38.77-6.19,17.36-6.2,38.77-6.2S475.94,351,475.94,354.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,328.36c-1.87.19-4.69,14.19-5.84,20.33a3.49,3.49,0,0,0,2.46,4,13.47,13.47,0,0,0,7.82.19,3.46,3.46,0,0,0,2.41-4.09C437,342.74,433.47,328.17,431.59,328.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,336.88c-1.24.13-3.12,9.43-3.89,13.52a2.33,2.33,0,0,0,1.64,2.65,9,9,0,0,0,5.2.12,2.3,2.3,0,0,0,1.6-2.72C443.64,346.44,441.27,336.75,440,336.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.29,339c-1.37.13-3.45,9.39-4.29,13.46a2.31,2.31,0,0,0,1.81,2.63,10.85,10.85,0,0,0,5.73.13,2.29,2.29,0,0,0,1.77-2.71C428.29,348.53,425.66,338.89,424.29,339Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.65,348.21c-.81.07-2,5.51-2.52,7.89a1.36,1.36,0,0,0,1.06,1.55,6.32,6.32,0,0,0,3.37.07,1.33,1.33,0,0,0,1-1.59C440,353.79,438.45,348.13,437.65,348.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.35,341.58c-1.09.09-2.73,6.57-3.4,9.42a1.64,1.64,0,0,0,1.43,1.84,9.88,9.88,0,0,0,4.55.09,1.61,1.61,0,0,0,1.4-1.9C449.51,348.24,447.44,341.49,446.35,341.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M446.35,341.58c-1.09.09-2.73,6.57-3.4,9.42a1.64,1.64,0,0,0,1.43,1.84,9.88,9.88,0,0,0,4.55.09,1.61,1.61,0,0,0,1.4-1.9C449.51,348.24,447.44,341.49,446.35,341.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M457.15,338.23c-1.43.12-3.6,8.66-4.48,12.41a2.16,2.16,0,0,0,1.89,2.43,12.78,12.78,0,0,0,6,.11,2.1,2.1,0,0,0,1.84-2.49C461.32,347,458.59,338.12,457.15,338.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M457.15,338.23c-1.43.12-3.6,8.66-4.48,12.41a2.16,2.16,0,0,0,1.89,2.43,12.78,12.78,0,0,0,6,.11,2.1,2.1,0,0,0,1.84-2.49C461.32,347,458.59,338.12,457.15,338.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.66,461.41c0,4.38-20.23,7.93-45.18,7.93s-45.17-3.55-45.17-7.93c0-.54.11-4.35.11-4.35,4.17-3.62,23.19-3.58,45.06-3.58,21.64,0,40.81-1,45.09,3.67C133.66,457.24,133.66,460.83,133.66,461.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.48,
    cy: 456.93,
    rx: 45.17,
    ry: 7.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,426.58c-2.18.22-5.48,16.54-6.82,23.7A4.07,4.07,0,0,0,78,454.91a15.7,15.7,0,0,0,9.12.23,4,4,0,0,0,2.8-4.78C88.32,443.34,84.16,426.36,82,426.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,436.51c-1.46.15-3.65,11-4.54,15.76a2.71,2.71,0,0,0,1.91,3.08,10.45,10.45,0,0,0,6.06.15,2.69,2.69,0,0,0,1.87-3.18C96,447.65,93.25,436.36,91.8,436.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,439c-1.6.15-4,10.95-5,15.69a2.69,2.69,0,0,0,2.11,3.07,12.67,12.67,0,0,0,6.69.14,2.64,2.64,0,0,0,2-3.15C78.12,450.09,75.06,438.85,73.46,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,449.71c-.94.08-2.36,6.42-2.94,9.2a1.59,1.59,0,0,0,1.24,1.8,7.37,7.37,0,0,0,3.92.09A1.55,1.55,0,0,0,92.46,459C91.76,456.22,90,449.62,89,449.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,442c-1.27.1-3.18,7.65-4,11a1.91,1.91,0,0,0,1.67,2.15,11.32,11.32,0,0,0,5.3.1,1.87,1.87,0,0,0,1.63-2.21C102.86,449.75,100.44,441.88,99.17,442Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.17,442c-1.27.1-3.18,7.65-4,11a1.91,1.91,0,0,0,1.67,2.15,11.32,11.32,0,0,0,5.3.1,1.87,1.87,0,0,0,1.63-2.21C102.86,449.75,100.44,441.88,99.17,442Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M111.76,438.09c-1.67.13-4.19,10.09-5.22,14.46-.29,1.25.67,2.46,2.2,2.82a14.88,14.88,0,0,0,7,.14c1.57-.38,2.52-1.64,2.15-2.91C116.62,448.31,113.43,438,111.76,438.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.76,438.09c-1.67.13-4.19,10.09-5.22,14.46-.29,1.25.67,2.46,2.2,2.82a14.88,14.88,0,0,0,7,.14c1.57-.38,2.52-1.64,2.15-2.91C116.62,448.31,113.43,438,111.76,438.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.6,164.66l-24.21,2.63v3.87s9.89.42,14.13,7.48h20.17c4.23-7.06,14.13-7.48,14.13-7.48v-3.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.6,164.66l-24.21,2.63v3.87s9.89.42,14.13,7.48h20.17c4.23-7.06,14.13-7.48,14.13-7.48v-3.87Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "365.04 167.29 425.86 167.29 414.64 159.31 376.56 159.31 365.04 167.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.37,152.83c-4.29,1.06-9.39,3-11.81,6.48h38.08s-2.62-4.41-10.87-6.56A31.24,31.24,0,0,0,388.37,152.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.87,
    y: 170.27,
    width: 73.35,
    height: 1.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.14,
    y: 178.64,
    width: 33.53,
    height: 1.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.69 180.42 392.05 185.79 399 185.79 404.66 180.42 386.69 180.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.78,120.92c.15,0,.26,6.89.26,15.38s-.11,15.39-.26,15.39-.26-6.89-.26-15.39S395.64,120.92,395.78,120.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.69,364.9s3.82-131,4.34-139.14,1.2-42,1.2-42h4l.41,181.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.9,364.9s-5.22-131-5.74-139.14-1.2-42-1.2-42h-4L396,365Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.57,159.16c0,.14-8.51.28-19,.3s-19-.08-19-.22,8.51-.28,19-.3S414.57,159,414.57,159.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.07,118.64s-.06-.2-.17-.53a2.26,2.26,0,0,0-.85-1.14,2.1,2.1,0,0,0-2-.25,2.05,2.05,0,0,0,0,3.84,2.1,2.1,0,0,0,2-.25,2.26,2.26,0,0,0,.85-1.14c.11-.33.13-.53.17-.53s.08.2,0,.58a2.21,2.21,0,0,1-.81,1.38,2.46,2.46,0,0,1-2.36.41,2.51,2.51,0,0,1,0-4.74,2.46,2.46,0,0,1,2.36.41,2.21,2.21,0,0,1,.81,1.38C398.15,118.44,398.1,118.64,398.07,118.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,157.56H378.07a8.76,8.76,0,0,1,1.7-1.27l28.42-.14Z",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.15,164.66a5.46,5.46,0,0,1-1.17.1l-3.2.08c-2.7,0-6.43.08-10.55.08l-7.16,0H400l-.06-.06c-1.7-1.59-3.1-2.93-4.08-3.88a12.46,12.46,0,0,1-1.48-1.55,13,13,0,0,1,1.66,1.35c1,.9,2.48,2.19,4.21,3.75l-.16-.06,7.16,0c4.12,0,7.85,0,10.55.08l3.2.08A4.38,4.38,0,0,1,422.15,164.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.78,180.45c0,.14-7.55.26-16.87.26s-16.88-.12-16.88-.26,7.56-.26,16.88-.26S412.78,180.3,412.78,180.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.78,178.53c0,.14-7.55.26-16.87.26s-16.88-.12-16.88-.26,7.56-.27,16.88-.27S412.78,178.38,412.78,178.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.9,364.9s0-.31-.06-.92-.07-1.52-.13-2.7c-.1-2.4-.26-5.9-.45-10.41-.37-9.06-.9-22.14-1.56-38.33-1.27-32.4-3-77.21-5-126.88l.17.24a8.36,8.36,0,0,0-3.26-.58,8.49,8.49,0,0,0-3.51.81l.15-.22c-1.51,49.62-2.87,94.37-3.85,126.72-.52,16.16-.94,29.23-1.23,38.26-.15,4.51-.27,8-.35,10.39-.05,1.18-.08,2.08-.11,2.7s-.05.92-.05.92,0-.31,0-.92,0-1.52.05-2.7c.06-2.39.15-5.89.26-10.39.25-9,.61-22.11,1.06-38.27.94-32.35,2.25-77.1,3.7-126.73v-.16l.14-.07a9.21,9.21,0,0,1,7.19-.25l.16.06v.17c1.89,49.67,3.59,94.48,4.81,126.88.59,16.19,1.07,29.28,1.4,38.34.15,4.51.27,8,.35,10.41,0,1.18.06,2.09.08,2.71S405.9,364.9,405.9,364.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 94.7 196.54 74.42 196.54 143.77 222.87 121.61 227.03 94.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.19,78.14c.15,0,.26,11.7.26,26.13s-.11,26.13-.26,26.13-.26-11.7-.26-26.13S201.05,78.14,201.19,78.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39,82.2c.14,0,.26,11.7.26,26.13s-.12,26.14-.26,26.14-.26-11.7-.26-26.14S207.25,82.2,207.39,82.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.64,85.39c.14,0,.26,11.7.26,26.13s-.12,26.13-.26,26.13-.26-11.7-.26-26.13S213.5,85.39,213.64,85.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.89,89.56c.14,0,.26,11.48.26,25.64s-.12,25.64-.26,25.64-.26-11.48-.26-25.64S219.74,89.56,219.89,89.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,78.91c-2.13,0-52.19,44.12-47.93,134.79V393.82h47.93Z",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,337.55c-.14,0-.26-42.59-.26-95.11s.12-95.13.26-95.13.26,42.58.26,95.13S196.22,337.55,196.08,337.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.88,182.1C234,182.25,209.5,205,209.5,205V346.81h26.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M219.89,330.81c-.15,0-.26-30.27-.26-67.61s.11-67.63.26-67.63.26,30.27.26,67.63S220,330.81,219.89,330.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.87,325.29c-.15,0-.26-30.27-.26-67.61s.11-67.63.26-67.63.26,30.27.26,67.63S226,325.29,225.87,325.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.85,319.77c-.15,0-.26-30.17-.26-67.38s.11-67.4.26-67.4.26,30.17.26,67.4S232,319.77,231.85,319.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.56,
    y: 155.81,
    width: 21.32,
    height: 2.69,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.56,
    y: 161.7,
    width: 21.32,
    height: 2.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.56,
    y: 167.66,
    width: 21.32,
    height: 2.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.76,
    y: 161.7,
    width: 2.89,
    height: 2.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.27,
    y: 161.7,
    width: 2.89,
    height: 2.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.12,86.37a9.82,9.82,0,0,1,.1,1.68c0,1.16.05,2.71.08,4.57,0,3.86.08,9.19.08,15.08,0,4.4,0,8.48,0,11.91l-.22-.22,3.87,0h.55v.34H232v-.32h.47l1.37,0,1.9.06a2.67,2.67,0,0,1,.68.07,3.1,3.1,0,0,1-.68.06l-1.9.06-1.37,0H232v-.32h.59v.34H232l-3.87,0h-.22v-.22c0-3.43,0-7.51,0-11.91,0-5.89,0-11.22.07-15.08,0-1.86.07-3.41.09-4.57A9.82,9.82,0,0,1,228.12,86.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.67,
    y: 123.34,
    width: 7.21,
    height: 2.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.91,336.33c-.14,0-.26-30.27-.26-67.61s.12-67.63.26-67.63.26,30.27.26,67.63S214.05,336.33,213.91,336.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.58,136.88c-1.75,0-42.78,36.17-39.29,110.5V395.05h39.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,348.92c-.14,0-.26-34.92-.26-78s.12-78,.26-78,.26,34.91.26,78S313.09,348.92,313,348.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.58,221.47C344,221.6,324,240.21,324,240.21v116.3h21.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 199.92,
    width: 17.48,
    height: 2.2,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 204.75,
    width: 17.48,
    height: 1.98,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 209.64,
    width: 17.48,
    height: 1.98,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.17,
    y: 204.75,
    width: 2.37,
    height: 1.98,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.48,
    y: 204.75,
    width: 2.37,
    height: 1.98,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,143a7.64,7.64,0,0,1,.1,1.38c0,1,.05,2.24.08,3.75.05,3.16.08,7.53.08,12.36,0,3.6,0,6.94-.05,9.76l-.21-.21,3.17,0h.45v.33h-.48v-.32h.38l1.12,0a15.26,15.26,0,0,1,2.12.12,12.59,12.59,0,0,1-2.12.13l-1.12,0h-.38v-.32h.48v.33h-.45l-3.17,0H339v-.22c0-2.82,0-6.16,0-9.76,0-4.83,0-9.2.07-12.36,0-1.51.06-2.77.09-3.75A6.63,6.63,0,0,1,339.22,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.67,
    y: 173.3,
    width: 5.91,
    height: 2.24,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.07,147.48c.14,0,.26,5.8.26,13s-.12,12.94-.26,12.94-.26-5.79-.26-12.94S271.92,147.48,272.07,147.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.12,113.58c.15,0,.26,13.4.26,29.92s-.11,29.93-.26,29.93-.26-13.39-.26-29.93S279,113.58,279.12,113.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 171.88,
    width: 24.51,
    height: 228.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.52 381.15 273.22 381.15 273.22 201.02 289.52 188.03 289.52 381.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,213.57a60.72,60.72,0,0,1-7.88.26,60.72,60.72,0,0,1-7.88-.26,58.65,58.65,0,0,1,7.88-.26A58.65,58.65,0,0,1,288.91,213.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,234.83a60.72,60.72,0,0,1-7.88.26,60.72,60.72,0,0,1-7.88-.26,60.72,60.72,0,0,1,7.88-.26A60.72,60.72,0,0,1,288.91,234.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,256.09a58.65,58.65,0,0,1-7.88.26,58.65,58.65,0,0,1-7.88-.26,60.72,60.72,0,0,1,7.88-.26A60.72,60.72,0,0,1,288.91,256.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,277.35a57.59,57.59,0,0,1-7.88.27,57.59,57.59,0,0,1-7.88-.27,60.72,60.72,0,0,1,7.88-.26A60.72,60.72,0,0,1,288.91,277.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,298.62a60.72,60.72,0,0,1-7.88.26,60.72,60.72,0,0,1-7.88-.26,58.65,58.65,0,0,1,7.88-.26A58.65,58.65,0,0,1,288.91,298.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,319.88a60.72,60.72,0,0,1-7.88.26,60.72,60.72,0,0,1-7.88-.26,60.72,60.72,0,0,1,7.88-.26A60.72,60.72,0,0,1,288.91,319.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,341.14a58.65,58.65,0,0,1-7.88.26,58.65,58.65,0,0,1-7.88-.26,60.72,60.72,0,0,1,7.88-.26A60.72,60.72,0,0,1,288.91,341.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,362.4a58.65,58.65,0,0,1-7.88.26,58.65,58.65,0,0,1-7.88-.26,60.72,60.72,0,0,1,7.88-.26A60.72,60.72,0,0,1,288.91,362.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38,112s-.06-.2-.17-.52a2.35,2.35,0,0,0-.83-1.13,2.11,2.11,0,0,0-1.95-.24,2,2,0,0,0,0,3.79,2.08,2.08,0,0,0,1.95-.25,2.29,2.29,0,0,0,.83-1.12c.11-.32.13-.53.17-.53s.09.21,0,.58a2.29,2.29,0,0,1-.81,1.37,2.43,2.43,0,0,1-2.33.4,2.48,2.48,0,0,1,0-4.69,2.43,2.43,0,0,1,2.33.4,2.29,2.29,0,0,1,.81,1.37C281.47,111.82,281.41,112,281.38,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.4,406.69c0,6.9-95.26,12.5-212.78,12.5s-212.78-5.6-212.78-12.5c0-.85.55-6.86.55-6.86,19.63-5.72,109.21-5.65,212.23-5.65,101.92,0,192.2-1.61,212.39,5.79C453.4,400.11,453.4,405.77,453.4,406.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.62,
    cy: 400.73,
    rx: 212.78,
    ry: 12.5,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,255.43l-20.92,2.28v3.34s8.55.36,12.21,6.47H79.07c3.67-6.11,12.21-6.47,12.21-6.47v-3.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.36,255.43l-20.92,2.28v3.34s8.55.36,12.21,6.47H79.07c3.67-6.11,12.21-6.47,12.21-6.47v-3.34Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "43.96 257.71 96.5 257.71 86.81 250.81 53.91 250.81 43.96 257.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.11,245.21c-3.7.92-8.1,2.6-10.2,5.6h32.9s-2.26-3.81-9.39-5.66A27.14,27.14,0,0,0,64.11,245.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.64,
    y: 260.28,
    width: 63.36,
    height: 1.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.15,
    y: 267.52,
    width: 28.97,
    height: 1.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.66 269.05 67.3 273.69 73.3 273.69 78.19 269.05 62.66 269.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.52,217.65c.15,0,.26,5.95.26,13.29s-.11,13.29-.26,13.29-.26-5.95-.26-13.29S70.38,217.65,70.52,217.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.66,401.62s3.3-86.38,3.76-93.4,1-36.32,1-36.32h3.47l.35,129.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.26,401.62s-4.51-86.38-5-93.4-1-36.32-1-36.32H69.79l.9,129.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75,250.68c0,.15-7.35.28-16.42.3s-16.42-.08-16.42-.23,7.35-.27,16.42-.29S86.75,250.54,86.75,250.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.49,215.68a2.63,2.63,0,0,0-.89-1.42,1.78,1.78,0,0,0-1.67-.21,1.75,1.75,0,0,0,0,3.26,1.78,1.78,0,0,0,1.67-.21,2.63,2.63,0,0,0,.89-1.42s.09.18,0,.51a2,2,0,0,1-.7,1.2,2.13,2.13,0,0,1-2.06.37,2.2,2.2,0,0,1,0-4.16,2.15,2.15,0,0,1,2.06.36,2,2,0,0,1,.7,1.21C72.58,215.5,72.52,215.68,72.49,215.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.24,249.3h-26a7.94,7.94,0,0,1,1.47-1.1l24.55-.11Z",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,255.43a3.61,3.61,0,0,1-1,.1l-2.77.09c-2.33,0-5.55.07-9.11.07l-6.18,0h-.09l-.07-.06c-1.46-1.38-2.67-2.54-3.51-3.37a8.37,8.37,0,0,1-1.27-1.35A10.23,10.23,0,0,1,70.74,252c.89.77,2.15,1.88,3.64,3.22l-.15-.06,6.18,0c3.56,0,6.78,0,9.11.08,1.17,0,2.12.05,2.77.08A4.16,4.16,0,0,1,93.3,255.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,269.07c0,.15-6.53.26-14.58.26s-14.58-.11-14.58-.26,6.53-.26,14.58-.26S85.21,268.93,85.21,269.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,267.41c0,.15-6.53.26-14.58.26s-14.58-.11-14.58-.26,6.53-.26,14.58-.26S85.21,267.27,85.21,267.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29,273.57c-.05.15-1.36-.32-3-.25s-2.94.6-3,.46a4.41,4.41,0,0,1,3-1A4.42,4.42,0,0,1,73.29,273.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.61 335.17 187.96 321.97 187.84 331.32 141.61 346.15 141.61 336.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 397.27 184.72 397.27 187.96 328.79 138.5 343.03 85.6 365.23 81.86 375.31 106.8 397.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14,406.23s-41.24-3.85-42-4.51-.86-26.41-.86-26.41l23,14.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.43,402s-34.69-10.95-47.36-25.33c0,0-6.55-7.72,7-14.24,10.68-5.14,61.29-21.94,61.29-21.94l0-10.13s-68.62,17.7-84.88,36.4c-6.2,7.12-3,13.93.71,17.8,14.36,15.08,38.92,21.65,38.92,21.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.94,201l-61.67,49.34v18.07h12.64c16.54.45,34.2,16.35,34.2,37.63,0,19.91-14.84,35.6-34.2,37.64H182.27v53.08l61.67.49c.36-1.08,12.87-166,12.82-196.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.94,201l-61.67,49.34v18.07h12.64c16.54.45,34.2,16.35,34.2,37.63,0,19.91-14.84,35.6-34.2,37.64H182.27v53.08l61.67.49c.36-1.08,12.87-166,12.82-196.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.21,344.61a38.55,38.55,0,1,0-8.3-76.18V250.36L256.58,201s.4,195,0,196.25l-61.67-.49V343.7A38.45,38.45,0,0,0,203.21,344.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,210.27s.27,0,.82,0l2.42,0,9.4-.06h.12v.13c0,16.62.08,49.43.14,87.13,0,27.54-.06,52.48-.08,70.55,0,9-.06,16.32-.08,21.39,0,2.5,0,4.46-.05,5.81l0,1.51c0,.34,0,.52,0,.52s0-.18,0-.52l0-1.51c0-1.35,0-3.31,0-5.81,0-5.07,0-12.37-.09-21.39,0-18.07,0-43-.07-70.55.05-37.7.11-70.51.13-87.13l.13.12-9.4-.06-2.42,0C232.62,210.29,232.35,210.27,232.35,210.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.68,259.29c0,.14-16.66.26-37.21.26s-37.2-.12-37.2-.26,16.65-.27,37.2-.27S256.68,259.14,256.68,259.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 370.05,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 741.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 372.31,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 745.65) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 374.56,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 750.16) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 376.82,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 754.68) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 378.99,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 759.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 381.25,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 763.53) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 383.5,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 768.04) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 385.76,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 772.56) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 263.56,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 528.15) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 265.81,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 532.66) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 268.07,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 537.17) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.22,
    y: 270.33,
    width: 10.26,
    height: 1.03,
    transform: "translate(464.69 541.69) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.27,
    y: 250.32,
    width: 30.01,
    height: 1.77,
    transform: "translate(394.56 502.42) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,343.51a36.08,36.08,0,0,1-6.18.26,36,36,0,0,1-6.17-.26,37.27,37.27,0,0,1,6.17-.26A37.35,37.35,0,0,1,194.62,343.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 279.31,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 288.38,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 297.45,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 306.52,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 315.58,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 324.65,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 333.72,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 342.79,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.92,
    y: 351.86,
    width: 5.84,
    height: 2.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.81,195.83l-24.21,2.64v3.86s9.89.43,14.13,7.49h20.16c4.24-7.06,14.13-7.49,14.13-7.49v-3.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.81,195.83l-24.21,2.64v3.86s9.89.43,14.13,7.49h20.16c4.24-7.06,14.13-7.49,14.13-7.49v-3.86Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "99.25 198.47 160.06 198.47 148.85 190.48 110.77 190.48 99.25 198.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.58,184c-4.29,1.07-9.39,3-11.81,6.48h38.08s-2.62-4.4-10.87-6.55A31.36,31.36,0,0,0,122.58,184Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 201.45,
    width: 73.35,
    height: 1.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.35,
    y: 209.82,
    width: 33.53,
    height: 1.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.9 211.6 126.26 216.96 133.21 216.96 138.87 211.6 120.9 211.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,152.1c.15,0,.26,6.89.26,15.38s-.11,15.38-.26,15.38-.26-6.88-.26-15.38S129.85,152.1,130,152.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,396.08s3.82-131,4.34-139.15,1.2-42,1.2-42h4l.4,181.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.11,396.08s-5.22-131-5.74-139.15-1.2-42-1.2-42h-4l1.05,181.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.77,190.33c0,.15-8.5.28-19,.31s-19-.08-19-.23,8.5-.27,19-.3S148.77,190.19,148.77,190.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,149.82c-.05,0-.06-.21-.17-.54a2.28,2.28,0,0,0-.85-1.13,2.1,2.1,0,0,0-2-.25,2.05,2.05,0,0,0,0,3.84,2.1,2.1,0,0,0,2-.25,2.3,2.3,0,0,0,.85-1.14c.11-.33.12-.53.17-.53s.08.2,0,.58a2.26,2.26,0,0,1-.81,1.38,2.46,2.46,0,0,1-2.36.41,2.51,2.51,0,0,1,0-4.74,2.46,2.46,0,0,1,2.36.41,2.26,2.26,0,0,1,.81,1.38A1,1,0,0,1,132.28,149.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,188.74H112.28a9.23,9.23,0,0,1,1.7-1.28l28.42-.13Z",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,195.83a4.83,4.83,0,0,1-1.17.1L152,196c-2.7,0-6.43.07-10.55.07l-7.16,0h-.09l-.06-.06c-1.7-1.59-3.1-2.93-4.08-3.88a14.24,14.24,0,0,1-1.49-1.55,11,11,0,0,1,1.67,1.35c1,.89,2.48,2.19,4.21,3.74l-.16-.06,7.16,0c4.12,0,7.85,0,10.55.08l3.2.08A5.58,5.58,0,0,1,156.36,195.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,211.62c0,.15-7.56.26-16.87.26s-16.88-.11-16.88-.26,7.56-.26,16.88-.26S147,211.48,147,211.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,209.7c0,.15-7.56.26-16.87.26s-16.88-.11-16.88-.26,7.56-.26,16.88-.26S147,209.56,147,209.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.11,396.08s0-.31-.06-.92-.08-1.53-.13-2.71c-.11-2.39-.26-5.89-.45-10.4-.37-9.06-.9-22.15-1.56-38.33-1.27-32.41-3-77.21-5-126.88l.17.23a8.74,8.74,0,0,0-3.26-.58,8.46,8.46,0,0,0-3.51.82l.15-.23c-1.51,49.63-2.87,94.37-3.86,126.73-.51,16.16-.93,29.22-1.22,38.26-.15,4.51-.27,8-.35,10.39,0,1.18-.09,2.08-.11,2.7s0,.92,0,.92,0-.31,0-.92,0-1.52,0-2.7c.06-2.39.15-5.89.26-10.39.25-9,.61-22.11,1.06-38.27.94-32.36,2.25-77.1,3.7-126.73v-.16l.14-.07a9,9,0,0,1,3.73-.87,9.17,9.17,0,0,1,3.46.62l.15.06v.17c1.88,49.67,3.58,94.48,4.81,126.88.59,16.19,1.07,29.28,1.4,38.34.15,4.51.27,8,.35,10.41,0,1.18.06,2.08.08,2.71S140.11,396.08,140.11,396.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,276.73,342.37,322v74.77h62.36c.21-.63,9.28-98.09,9.23-120.06Zm-32.31,88.18a23.17,23.17,0,0,1-4.52-.45v-.13c-10.71-2.08-16.3-11.43-16.3-22.75,0-11.14,5.34-20.52,15.79-22.8h0a23.78,23.78,0,0,1,5-.55,23.34,23.34,0,0,1,0,46.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404.73,276.73,342.37,322v74.77h62.36c.21-.63,9.28-98.09,9.23-120.06Zm-32.31,88.18a23.17,23.17,0,0,1-4.52-.45v-.13c-10.71-2.08-16.3-11.43-16.3-22.75,0-11.14,5.34-20.52,15.79-22.8h0a23.78,23.78,0,0,1,5-.55,23.34,23.34,0,0,1,0,46.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M414,276.73,351.6,322v74.77H414C414.21,396.07,414,276.73,414,276.73Zm-32.31,88.18a23.15,23.15,0,0,1-4.51-.45v-.13a23.26,23.26,0,0,1-.51-45.55h0a23.76,23.76,0,0,1,5-.55,23.34,23.34,0,1,1,0,46.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.75,283.58s.07,0,.19,0l.57,0,2.19,0,8.25-.07h.14v.15c0,11.24.06,29.87.11,51,0,17.16-.06,32.69-.08,44,0,5.6-.06,10.14-.08,13.32,0,1.55,0,2.76-.05,3.62,0,.4,0,.71,0,.95a2,2,0,0,1,0,.32,1.34,1.34,0,0,1,0-.32c0-.24,0-.55,0-.95,0-.86,0-2.07,0-3.62,0-3.18-.05-7.72-.09-13.32,0-11.28,0-26.81-.07-44,0-21.11.08-39.74.11-51l.15.15-8.25-.07-2.19,0-.57,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,313.26c0-.15,13.2-.26,29.47-.26s29.47.11,29.47.26-13.2.26-29.47.26S355.09,313.4,355.09,313.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 380.32,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 761.26) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 381.68,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 763.99) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 383.05,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 766.72) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 384.41,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 769.45) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 385.73,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 772.08) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 387.09,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 774.81) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 388.46,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 777.55) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 389.83,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 780.28) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 315.84,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 632.31) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 317.21,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 635.04) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 318.57,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 637.77) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 319.94,
    width: 6.21,
    height: 0.63,
    transform: "translate(798.59 640.51) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 323.66,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 329.15,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 334.64,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 340.13,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 345.62,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 351.1,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 356.59,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 362.08,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.37,
    y: 367.57,
    width: 12.62,
    height: 1.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.19 301.81 167.24 247.58 160.23 247.58 136.06 260.61 136.06 279.25 163.19 301.81",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "163.19 301.81 167.24 247.58 160.23 247.58 136.06 260.61 136.06 279.25 163.19 301.81"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "167.24 301.81 167.24 247.58 141.58 260.77 141.72 281.21 167.24 301.81",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 277.91,
    width: 6.66,
    height: 118.67,
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.93 277.91 137.93 396.48 170.59 397.19 170.59 304.54 137.93 277.91",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.56,310.19s-24.52,8.54-23.49,39.07,23.64,34.19,23.64,34.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,382.38c-.14,0-.26-15.48-.26-34.57s.12-34.58.26-34.58.26,15.48.26,34.58S166.5,382.38,166.35,382.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,377.46c-.14,0-.26-13.77-.26-30.75S160.86,316,161,316s.26,13.77.26,30.76S161.15,377.46,161,377.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,373.27c-.14,0-.26-11.32-.26-25.28s.12-25.29.26-25.29.26,11.32.26,25.29S155.79,373.27,155.65,373.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3,364.25c-.15,0-.26-7.61-.26-17s.11-17,.26-17,.26,7.61.26,17S150.44,364.25,150.3,364.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 305.11,
    width: 24.38,
    height: 2.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 310.03,
    width: 12.19,
    height: 2.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 277.91,
    width: 6.66,
    height: 118.67
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M131.27,277.91a2.43,2.43,0,0,1,.46-.05l1.31,0,4.89-.08H138l0,0c3.45,2.74,8.37,6.71,13.8,11.14,5.22,4.26,9.93,8.13,13.33,11l4,3.37,1.07.93c.24.22.36.34.35.36a1.82,1.82,0,0,1-.42-.28L169,303.4l-4.11-3.24c-3.45-2.75-8.19-6.58-13.42-10.84-5.43-4.43-10.31-8.45-13.69-11.27l.11,0L133,278l-1.31-.05A1.31,1.31,0,0,1,131.27,277.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.61,260.71a15.15,15.15,0,0,1-5.59,0,7.58,7.58,0,0,1,2.8-.26A7.55,7.55,0,0,1,141.61,260.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.24 288.46 162.12 288.46 162.12 263.39 167.24 260.28 167.24 288.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.82,
    y: 310.03,
    width: 2.85,
    height: 2.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,236.77a2.52,2.52,0,0,1-.5.15l-1.42.35-5.26,1.18-17.36,3.94-17.34,4-5.27,1.2-1.43.3a2.75,2.75,0,0,1-.51.07,1.81,1.81,0,0,1,.48-.18l1.42-.39,5.22-1.36c4.42-1.11,10.53-2.6,17.31-4.17s12.93-2.88,17.4-3.79c2.23-.45,4-.8,5.3-1l1.44-.25A1.85,1.85,0,0,1,305.77,236.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.29,268.51a9.31,9.31,0,0,1-2.08.87c-1.3.47-3.11,1.08-5.12,1.73s-3.84,1.21-5.17,1.59a10,10,0,0,1-2.19.52,9.07,9.07,0,0,1,2.07-.87c1.3-.47,3.12-1.08,5.13-1.73s3.84-1.21,5.17-1.59A10,10,0,0,1,182.29,268.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,289.56s-.43.2-1.28.56l-3.74,1.62c-3.29,1.44-8.14,3.56-14.24,6.58-3.05,1.51-6.41,3.26-10,5.33A73.35,73.35,0,0,0,83,311.27c-1.76,1.6-3.64,3.39-4.55,5.78a5.06,5.06,0,0,0-.3,1.85,3.85,3.85,0,0,0,.57,1.8,7.24,7.24,0,0,0,3,2.48,28.72,28.72,0,0,0,8.08,2.23,86.56,86.56,0,0,0,8.85.81c12.17.47,25.51-.5,39.74-2s29.38-3.79,45.25-6.55c31.73-5.54,66.34-13.19,102.26-22.71s69.81-20.08,99.84-31.72c7.5-2.93,14.76-5.93,21.7-9.09A193.48,193.48,0,0,0,427.12,244a65.4,65.4,0,0,0,8.59-6.06,22.85,22.85,0,0,0,3.49-3.68,6.14,6.14,0,0,0,1.45-4.52,1.57,1.57,0,0,0-.16-.56,3.71,3.71,0,0,0-.22-.55,4.66,4.66,0,0,0-.7-.95,4.8,4.8,0,0,0-.89-.79l-.49-.35-.52-.29a18,18,0,0,0-4.46-1.69,53.87,53.87,0,0,0-9.2-1.43,158.92,158.92,0,0,0-17.35-.25c-5.48.18-10.64.53-15.46.92-9.64.81-17.92,1.81-24.67,2.69s-12,1.66-15.54,2.19l-4,.61c-.91.14-1.38.19-1.38.19l1.37-.24,4-.66c3.54-.56,8.77-1.38,15.52-2.29s15-1.94,24.67-2.78c4.83-.4,10-.77,15.48-1a159.35,159.35,0,0,1,17.39.21,56.13,56.13,0,0,1,9.27,1.42,19.33,19.33,0,0,1,4.55,1.72l.55.31.5.37a4.68,4.68,0,0,1,.95.83,6,6,0,0,1,.77,1,6.25,6.25,0,0,1,.24.6,2.38,2.38,0,0,1,.18.63,4.9,4.9,0,0,1-.27,2.57,9.52,9.52,0,0,1-1.25,2.25,22.14,22.14,0,0,1-3.55,3.76,66.71,66.71,0,0,1-8.64,6.12,194.27,194.27,0,0,1-19.73,10.21c-6.95,3.17-14.21,6.18-21.71,9.12-30,11.67-63.95,22.2-99.88,31.77S215.45,312.6,183.7,318.12c-15.87,2.75-31,5-45.28,6.51s-27.6,2.45-39.8,1.95a87.53,87.53,0,0,1-8.9-.82,29.18,29.18,0,0,1-8.17-2.28,7.58,7.58,0,0,1-3.15-2.61,4.29,4.29,0,0,1-.61-1.95,5.32,5.32,0,0,1,.33-2,16,16,0,0,1,4.65-5.89,72.51,72.51,0,0,1,11.15-7.61c3.6-2.06,7-3.8,10-5.3,6.12-3,11-5.09,14.29-6.5l3.76-1.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.46,286.64l-27.37,7.84a2.22,2.22,0,0,1-2.75-1.53h0a2.23,2.23,0,0,1,1.53-2.76l27.36-7.84a2.21,2.21,0,0,1,2.75,1.53h0A2.23,2.23,0,0,1,315.46,286.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,225.14c-14.39-.82-29.37,1.33-43.66,2.93h0c-2.39.26-4.2-2.19-4.3-4.3-.11-2.5,2.07-4.05,4.3-4.29s4.38-.48,6.57-.7c7.91-.78,15.85-1.38,23.81-1.58a131.08,131.08,0,0,1,17.61.53c6.78.75,18.43,2.4,18.79,11.32.13,3.18-1.68,6-3.67,8.32a43,43,0,0,1-8.65,7.15c-9.43,6.34-20,11.11-30.38,15.58-15.46,6.63-31.27,12.42-47.21,17.78-2.28.77-4.6-.88-5.29-3a4.38,4.38,0,0,1,3-5.28c2.15-.72,4.28-1.45,6.42-2.18,7.83-2.71,15.62-5.52,23.34-8.5q5.23-2,10.43-4.15l2.66-1.11.62-.25c-.13.05-.84.35-.11,0l1.06-.45c1.57-.67,3.13-1.35,4.7-2,0,0,19.36-9.2,25-13,5.07-3.38,9.43-6.28,8.36-9.06C433.24,225.89,421,225.14,421,225.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,225.14s.38,0,1.11.06,1.83.15,3.25.34a37.87,37.87,0,0,1,5.2,1,10.28,10.28,0,0,1,3.11,1.33,2.8,2.8,0,0,1,.67.66,2.43,2.43,0,0,1,.34.93,3,3,0,0,1-.47,1.95,12.2,12.2,0,0,1-3,3.11c-1.18.93-2.49,1.83-3.85,2.75a89.46,89.46,0,0,1-9.27,5.38c-3.41,1.79-7.08,3.63-11,5.56l-6,2.92-3.2,1.4-1.63.71-.82.35-.21.09-.1,0-.05,0h0c0,.09-.3-.68-.15-.36l.4-.17.17.35c-3.55,1.52-7.27,2.95-11.12,4.5l-2.91,1.16-3,1.09-6.13,2.24-12.8,4.67c-2.2.8-4.44,1.53-6.7,2.31a8.8,8.8,0,0,0-1.63.65,4.9,4.9,0,0,0-1.29,1.11,3.72,3.72,0,0,0-.81,3.21,4.52,4.52,0,0,0,2,2.74,3.65,3.65,0,0,0,3.37.27l7.16-2.45q7.22-2.5,14.64-5.25c9.88-3.66,20-7.7,30.14-12.19,5.64-2.49,11.15-5.08,16.4-8,2.62-1.44,5.18-3,7.65-4.58a64,64,0,0,0,7.06-5.17,22.2,22.2,0,0,0,5.36-6.57,9,9,0,0,0,1-4,7,7,0,0,0-.09-1,6.65,6.65,0,0,0-.16-1l-.3-1a5.48,5.48,0,0,0-.43-.92,9,9,0,0,0-1.13-1.68,11.38,11.38,0,0,0-1.51-1.35,15.13,15.13,0,0,0-3.54-2,34.35,34.35,0,0,0-7.78-2,104.56,104.56,0,0,0-15.53-1.08c-5.05,0-10,.17-14.69.44s-9.31.66-13.7,1.08l-6.44.66c-.52.06-1.06.1-1.56.18a5.53,5.53,0,0,0-1.43.45,4.14,4.14,0,0,0-2.06,2,4.46,4.46,0,0,0,1.52,5.06,3.28,3.28,0,0,0,2.56.64l2.75-.31,10.22-1.15c6.38-.7,11.89-1.15,16.41-1.35s8-.19,10.4-.11,3.62.19,3.62.19-.31,0-.92,0-1.51-.07-2.7-.07c-2.38-.05-5.89,0-10.39.2s-10,.72-16.39,1.44l-10.21,1.19-2.75.31a3.58,3.58,0,0,1-2.81-.69,5.2,5.2,0,0,1-1.72-2.44,4.28,4.28,0,0,1,.07-3,4.55,4.55,0,0,1,2.24-2.19,6.21,6.21,0,0,1,1.53-.49c.54-.09,1.05-.12,1.58-.18l6.44-.68c4.39-.43,9-.82,13.71-1.11s9.66-.47,14.73-.47A105.57,105.57,0,0,1,429,218a36,36,0,0,1,7.9,2,15.42,15.42,0,0,1,3.65,2,11.71,11.71,0,0,1,1.58,1.41,9.26,9.26,0,0,1,1.2,1.78,5.74,5.74,0,0,1,.46,1l.32,1a7.46,7.46,0,0,1,.17,1.07,7.74,7.74,0,0,1,.09,1.08,9.48,9.48,0,0,1-1,4.21,22.8,22.8,0,0,1-5.48,6.74,63.3,63.3,0,0,1-7.11,5.21c-2.48,1.63-5.05,3.15-7.68,4.61-5.27,2.91-10.79,5.5-16.44,8-10.17,4.49-20.28,8.54-30.18,12.2q-7.41,2.74-14.65,5.24L354.61,278a4.27,4.27,0,0,1-1.92.3,4.32,4.32,0,0,1-1.86-.62,5,5,0,0,1-2.24-3.05,4.18,4.18,0,0,1,.9-3.62,5.43,5.43,0,0,1,1.43-1.23,9.36,9.36,0,0,1,1.71-.68c2.26-.78,4.51-1.51,6.7-2.3l12.81-4.65,6.13-2.23,3-1.09,2.92-1.14c3.84-1.54,7.58-3,11.1-4.46l.17.35-.42.18c.13.33-.23-.42-.17-.35l0,0,.05,0,.11,0,.21-.09.82-.35,1.63-.7,3.19-1.39,6-2.91q5.87-2.85,11-5.5a92.16,92.16,0,0,0,9.27-5.33c1.37-.92,2.67-1.81,3.85-2.73a11.71,11.71,0,0,0,2.95-3,2.78,2.78,0,0,0,.45-1.81,2.15,2.15,0,0,0-.29-.84,2.65,2.65,0,0,0-.63-.62,10.25,10.25,0,0,0-3-1.33,39.35,39.35,0,0,0-5.17-1.06c-1.41-.2-2.5-.32-3.23-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.8,219.78c0-.05.52.22,1.09.88a6.2,6.2,0,0,1,1.36,3.1,6.12,6.12,0,0,1-.53,3.35c-.38.79-.78,1.17-.83,1.13a9.14,9.14,0,0,1,.49-1.27,7,7,0,0,0,.35-3.14,6.77,6.77,0,0,0-1.14-2.94C376.13,220.2,375.75,219.84,375.8,219.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.72,278.5c-.06-.06.43-.47.88-1.35a4.72,4.72,0,0,0-.75-5.43,3.18,3.18,0,0,0-1.42-.84,2.66,2.66,0,0,0-1.53.11s.08-.16.34-.31a1.92,1.92,0,0,1,1.26-.16,3.32,3.32,0,0,1,1.68.85,4.84,4.84,0,0,1,1.22,1.95,4.72,4.72,0,0,1-.48,4C353.34,278.23,352.74,278.55,352.72,278.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35,270.57a13,13,0,0,1,.24-1.35,6,6,0,0,0-2.32-5.68c-.66-.51-1.15-.72-1.12-.8a2.51,2.51,0,0,1,1.33.5,5.6,5.6,0,0,1,2.47,6.05C374.73,270.15,374.41,270.6,374.35,270.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.43,251.23s.05-.43,0-1.23a7.24,7.24,0,0,0-.84-3.29l.18.06c-4.43,2-11.92,5.21-20.43,8.84L381.79,263l-5.35,2.19-1.47.58a1.93,1.93,0,0,1-.52.16,3,3,0,0,1,.48-.26l1.43-.66,5.29-2.35,17.53-7.56c8.5-3.63,16-6.79,20.52-8.63l.13-.05.05.11a7.07,7.07,0,0,1,.75,3.44,5.1,5.1,0,0,1-.11.92C420.48,251.13,420.45,251.24,420.43,251.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.67,
    y: 222.2,
    width: 6.64,
    height: 1.28,
    transform: "translate(-15.91 30.83) rotate(-4.39)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M375.88,219.83a4.05,4.05,0,0,0-2.83,3.59,4.61,4.61,0,0,0,2.36,4.28,1.84,1.84,0,0,0,1.68.15,2,2,0,0,0,.84-1.18,5.73,5.73,0,0,0-.06-3.79,5.37,5.37,0,0,0-2-3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M351.33,270.87a1.37,1.37,0,0,0-1.49.2,2.59,2.59,0,0,0-.82,1.35,4.67,4.67,0,0,0,1.62,4.85,2.47,2.47,0,0,0,2.16.55,2.13,2.13,0,0,0,1.17-1.06,4,4,0,0,0,.37-1.55,5.23,5.23,0,0,0-.45-2.71,3.24,3.24,0,0,0-2-1.76"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,238.26l-27.78,6.21a2.23,2.23,0,0,1-2.67-1.69h0a2.24,2.24,0,0,1,1.69-2.66l27.78-6.21a2.24,2.24,0,0,1,2.67,1.69h0A2.24,2.24,0,0,1,296.16,238.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,318.24c-1.1.09-2.75,6.62-3.43,9.49a1.66,1.66,0,0,0,1.45,1.86,9.87,9.87,0,0,0,4.58.09,1.62,1.62,0,0,0,1.41-1.91C181.64,325,179.55,318.15,178.45,318.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88,380.1c-1.51.15-3.79,11.43-4.72,16.39a2.81,2.81,0,0,0,2,3.21,10.92,10.92,0,0,0,6.3.15,2.79,2.79,0,0,0,1.94-3.3C345.27,391.69,342.39,379.94,340.88,380.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,380.65c-1.51.16-3.79,11.44-4.72,16.4a2.81,2.81,0,0,0,2,3.2,10.85,10.85,0,0,0,6.3.16,2.79,2.79,0,0,0,1.94-3.31C374,392.25,371.14,380.5,369.63,380.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,384.73c-1,.1-2.61,7.87-3.24,11.28a1.93,1.93,0,0,0,1.36,2.21,7.48,7.48,0,0,0,4.34.11,1.92,1.92,0,0,0,1.34-2.27C360,392.71,358,384.62,357,384.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,392.53c-.69.06-1.73,4.72-2.16,6.76a1.16,1.16,0,0,0,.91,1.32,5.44,5.44,0,0,0,2.88.07,1.16,1.16,0,0,0,.89-1.37C354.5,397.31,353.19,392.46,352.5,392.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,387.25c-1.08.11-2.71,8.16-3.37,11.7a2,2,0,0,0,1.42,2.29,7.68,7.68,0,0,0,4.5.11,2,2,0,0,0,1.38-2.36C251.58,395.52,249.52,387.14,248.45,387.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,390.9c-.69.06-1.73,4.72-2.16,6.76a1.17,1.17,0,0,0,.91,1.32,5.44,5.44,0,0,0,2.88.07,1.16,1.16,0,0,0,.89-1.37C244.79,395.68,243.48,390.83,242.79,390.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.86,380.7c-1.89.15-4.75,11.43-5.92,16.39-.33,1.42.76,2.8,2.49,3.21a17.12,17.12,0,0,0,7.92.15c1.78-.43,2.85-1.86,2.43-3.3C157.37,392.29,153.75,380.54,151.86,380.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.94,384.53c-1.21.12-3,9.2-3.79,13.18a2.26,2.26,0,0,0,1.59,2.58,8.82,8.82,0,0,0,5.08.13,2.25,2.25,0,0,0,1.56-2.66C147.47,393.85,145.16,384.4,143.94,384.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.78,391.4c-.69.06-1.73,4.72-2.16,6.76a1.16,1.16,0,0,0,.91,1.32,5.44,5.44,0,0,0,2.88.07,1.15,1.15,0,0,0,.89-1.36C138.79,396.18,137.47,391.34,136.78,391.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71,393.88c-1.1.09-2.75,6.62-3.43,9.49a1.66,1.66,0,0,0,1.44,1.86,10.05,10.05,0,0,0,4.59.09,1.63,1.63,0,0,0,1.41-1.92C150.9,400.59,148.81,393.79,147.71,393.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.71,393.88c-1.1.09-2.75,6.62-3.43,9.49a1.66,1.66,0,0,0,1.44,1.86,10.05,10.05,0,0,0,4.59.09,1.63,1.63,0,0,0,1.41-1.92C150.9,400.59,148.81,393.79,147.71,393.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,390.72c-.88.07-2.21,5.3-2.75,7.59a1.33,1.33,0,0,0,1.16,1.49,8,8,0,0,0,3.66.07c.83-.2,1.33-.86,1.13-1.53C164.43,396.09,162.75,390.65,161.88,390.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.88,390.72c-.88.07-2.21,5.3-2.75,7.59a1.33,1.33,0,0,0,1.16,1.49,8,8,0,0,0,3.66.07c.83-.2,1.33-.86,1.13-1.53C164.43,396.09,162.75,390.65,161.88,390.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M177.3,396.87c-.88.07-2.2,5.29-2.74,7.59a1.31,1.31,0,0,0,1.15,1.48,7.73,7.73,0,0,0,3.67.07,1.29,1.29,0,0,0,1.13-1.52C179.85,402.24,178.18,396.8,177.3,396.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3,396.87c-.88.07-2.2,5.29-2.74,7.59a1.31,1.31,0,0,0,1.15,1.48,7.73,7.73,0,0,0,3.67.07,1.29,1.29,0,0,0,1.13-1.52C179.85,402.24,178.18,396.8,177.3,396.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,387.87c-1.51.15-3.79,11.44-4.71,16.39a2.81,2.81,0,0,0,2,3.21,10.89,10.89,0,0,0,6.31.16,2.8,2.8,0,0,0,1.94-3.31C224.52,399.46,221.64,387.72,220.13,387.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35,381.58c-1.51.16-3.79,11.44-4.71,16.4a2.81,2.81,0,0,0,2,3.2,10.89,10.89,0,0,0,6.31.16,2.8,2.8,0,0,0,1.94-3.3C198.74,393.18,195.86,381.43,194.35,381.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.14,388.45c-1,.1-2.51,7.61-3.13,10.9a1.88,1.88,0,0,0,1.32,2.14,7.3,7.3,0,0,0,4.19.1,1.85,1.85,0,0,0,1.29-2.2C204.06,396.16,202.15,388.35,201.14,388.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,394.22c-.69.06-1.73,4.72-2.16,6.76a1.17,1.17,0,0,0,.91,1.33,5.52,5.52,0,0,0,2.88.06A1.15,1.15,0,0,0,217,401C216.51,399,215.19,394.16,214.5,394.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,390.17c-1.11.1-2.78,7.57-3.46,10.85a1.86,1.86,0,0,0,1.46,2.12,8.76,8.76,0,0,0,4.62.11,1.85,1.85,0,0,0,1.43-2.19C191.68,397.84,189.57,390.07,188.46,390.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25,392.24c-.88.07-2.2,5.3-2.74,7.59a1.32,1.32,0,0,0,1.15,1.49,8,8,0,0,0,3.67.07,1.29,1.29,0,0,0,1.12-1.53C208.8,397.61,207.12,392.17,206.25,392.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.25,392.24c-.88.07-2.2,5.3-2.74,7.59a1.32,1.32,0,0,0,1.15,1.49,8,8,0,0,0,3.67.07,1.29,1.29,0,0,0,1.12-1.53C208.8,397.61,207.12,392.17,206.25,392.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M263.9,373.27c-1.32.13-3.3,10-4.11,14.29a2.45,2.45,0,0,0,1.73,2.79,9.45,9.45,0,0,0,5.49.14,2.44,2.44,0,0,0,1.7-2.88C267.72,383.38,265.21,373.14,263.9,373.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.87,378.65c-1.08.11-2.7,8.16-3.37,11.7a2,2,0,0,0,1.42,2.29,7.68,7.68,0,0,0,4.5.11,2,2,0,0,0,1.39-2.36C276,386.92,274,378.54,272.87,378.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.92,391.32c-.69.07-1.73,4.72-2.16,6.77a1.17,1.17,0,0,0,.91,1.32,5.42,5.42,0,0,0,2.88.06,1.13,1.13,0,0,0,.89-1.36C283.93,396.11,282.61,391.26,281.92,391.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.26,390.51c-1.4.11-3.51,8.44-4.37,12.1a2.11,2.11,0,0,0,1.84,2.37,12.59,12.59,0,0,0,5.85.11,2.06,2.06,0,0,0,1.79-2.44C271.33,399.07,268.66,390.39,267.26,390.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M267.26,390.51c-1.4.11-3.51,8.44-4.37,12.1a2.11,2.11,0,0,0,1.84,2.37,12.59,12.59,0,0,0,5.85.11,2.06,2.06,0,0,0,1.79-2.44C271.33,399.07,268.66,390.39,267.26,390.51Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 282.86,
    y: 279.1,
    width: 6.66,
    height: 118.67,
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.52 279.1 289.52 397.66 322.18 398.38 322.18 305.72 289.52 279.1",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M322.15,311.37s-24.53,8.54-23.49,39.07,23.64,34.19,23.64,34.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M317.94,383.57c-.14,0-.26-15.49-.26-34.58s.12-34.58.26-34.58.26,15.48.26,34.58S318.08,383.57,317.94,383.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.59,378.65c-.15,0-.26-13.78-.26-30.76s.11-30.76.26-30.76.26,13.77.26,30.76S312.73,378.65,312.59,378.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.24,374.45c-.15,0-.26-11.32-.26-25.28s.11-25.28.26-25.28.26,11.31.26,25.28S307.38,374.45,307.24,374.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.88,365.43c-.14,0-.26-7.61-.26-17s.12-17,.26-17,.26,7.61.26,17S302,365.43,301.88,365.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 282.86,
    y: 279.1,
    width: 6.66,
    height: 118.67
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M307.93,388.55a22.75,22.75,0,0,0-1.23-4.18,4.65,4.65,0,0,0-3.91-2.5v0l-.21,0-.22,0v0a4.65,4.65,0,0,0-3.91,2.5,22.72,22.72,0,0,0-1.22,4.18,19,19,0,0,0-.88,5.35,6.06,6.06,0,0,0,2,4.57,6.29,6.29,0,0,0,4.26,1.12c1.72,0,3.17-.19,4.26-1.12a6.08,6.08,0,0,0,2-4.57A19.3,19.3,0,0,0,307.93,388.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,381.15c-1.51.16-3.78,11.44-4.71,16.39a2.81,2.81,0,0,0,2,3.21,10.89,10.89,0,0,0,6.31.16,2.8,2.8,0,0,0,1.94-3.31C323.38,392.75,320.5,381,319,381.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,380.83c-.82.08-2.05,6.19-2.55,8.87a1.51,1.51,0,0,0,1.07,1.73,5.85,5.85,0,0,0,3.41.09,1.52,1.52,0,0,0,1.05-1.79C328.93,387.1,327.37,380.74,326.56,380.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.79,383.69c-.69.07-1.73,4.72-2.15,6.77a1.15,1.15,0,0,0,.9,1.32,5.46,5.46,0,0,0,2.89.06,1.14,1.14,0,0,0,.88-1.36C332.8,388.48,331.48,383.63,330.79,383.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,393.09c-.77.06-1.93,4.64-2.41,6.65a1.16,1.16,0,0,0,1,1.3,7,7,0,0,0,3.21.07,1.14,1.14,0,0,0,1-1.34C326,397.79,324.52,393,323.75,393.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M323.75,393.09c-.77.06-1.93,4.64-2.41,6.65a1.16,1.16,0,0,0,1,1.3,7,7,0,0,0,3.21.07,1.14,1.14,0,0,0,1-1.34C326,397.79,324.52,393,323.75,393.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M415.06,380.08c-1.51.15-3.79,11.44-4.71,16.39a2.81,2.81,0,0,0,2,3.21,10.87,10.87,0,0,0,6.31.15,2.8,2.8,0,0,0,1.94-3.3C419.45,391.67,416.57,379.92,415.06,380.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,388c-.69.06-1.73,4.72-2.16,6.76a1.17,1.17,0,0,0,.91,1.32,5.44,5.44,0,0,0,2.88.07,1.16,1.16,0,0,0,.89-1.37C428.11,392.81,426.79,388,426.1,388Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,392c-.77.06-1.93,4.64-2.41,6.65a1.17,1.17,0,0,0,1,1.3,6.88,6.88,0,0,0,3.22.06,1.13,1.13,0,0,0,1-1.34C411.52,396.73,410.05,392,409.29,392Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M409.29,392c-.77.06-1.93,4.64-2.41,6.65a1.17,1.17,0,0,0,1,1.3,6.88,6.88,0,0,0,3.22.06,1.13,1.13,0,0,0,1-1.34C411.52,396.73,410.05,392,409.29,392Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M91.94,349.07c-1.09.09-2.75,6.62-3.42,9.49A1.64,1.64,0,0,0,90,360.42a10,10,0,0,0,4.58.09A1.62,1.62,0,0,0,96,358.59C95.13,355.78,93,349,91.94,349.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57,345.38c-.69.06-1.74,4.19-2.17,6a1.05,1.05,0,0,0,.91,1.18,6.31,6.31,0,0,0,2.9.05c.65-.16,1.05-.68.89-1.21C104.59,349.63,103.26,345.33,102.57,345.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,347.22c-.7,0-1.74,4.18-2.17,6a1,1,0,0,0,.91,1.17,6.2,6.2,0,0,0,2.9.06,1,1,0,0,0,.89-1.21C115,351.46,113.65,347.16,113,347.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.39,344.58c-.53.05-1.33,3.2-1.65,4.59a.79.79,0,0,0,.69.9,4.63,4.63,0,0,0,2.22,0c.5-.12.8-.52.68-.92C108.94,347.83,107.92,344.54,107.39,344.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,364.76c-.53.05-1.33,3.2-1.66,4.59a.8.8,0,0,0,.7.9,4.63,4.63,0,0,0,2.22,0,.79.79,0,0,0,.68-.92C77.78,368,76.77,364.72,76.24,364.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,360.84c-.53,0-1.33,3.2-1.65,4.59a.8.8,0,0,0,.69.9,4.9,4.9,0,0,0,2.22,0,.78.78,0,0,0,.68-.93C86.31,364.08,85.29,360.8,84.76,360.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.81,361.6c-1.1.09-2.75,6.63-3.43,9.5A1.64,1.64,0,0,0,77.82,373a9.78,9.78,0,0,0,4.59.09,1.62,1.62,0,0,0,1.41-1.91C83,368.32,80.91,361.52,79.81,361.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.81,361.6c-1.1.09-2.75,6.63-3.43,9.5A1.64,1.64,0,0,0,77.82,373a9.78,9.78,0,0,0,4.59.09,1.62,1.62,0,0,0,1.41-1.91C83,368.32,80.91,361.52,79.81,361.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,350.67c-.79.06-2,4.8-2.48,6.89a1.19,1.19,0,0,0,1,1.34,7.24,7.24,0,0,0,3.33.07,1.17,1.17,0,0,0,1-1.39C98.49,355.54,97,350.6,96.17,350.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.17,350.67c-.79.06-2,4.8-2.48,6.89a1.19,1.19,0,0,0,1,1.34,7.24,7.24,0,0,0,3.33.07,1.17,1.17,0,0,0,1-1.39C98.49,355.54,97,350.6,96.17,350.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.45,339.57c-.79.07-2,4.81-2.49,6.89a1.21,1.21,0,0,0,1.05,1.35,7.21,7.21,0,0,0,3.33.06,1.17,1.17,0,0,0,1-1.39C118.77,344.44,117.25,339.51,116.45,339.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45,339.57c-.79.07-2,4.81-2.49,6.89a1.21,1.21,0,0,0,1.05,1.35,7.21,7.21,0,0,0,3.33.06,1.17,1.17,0,0,0,1-1.39C118.77,344.44,117.25,339.51,116.45,339.57Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Airplanes--inject-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.51,172.3a2.56,2.56,0,0,0-1.19-1.49,1.85,1.85,0,0,0-2.19,1.11,5.35,5.35,0,0,0-.24,2.67,3.1,3.1,0,0,0-5-.73,8,8,0,0,1-.85,1.07,3.56,3.56,0,0,1-2.3.59,266.83,266.83,0,0,0-27.23,2,10.74,10.74,0,0,0,4.65.78c11.18.24,23.71-.12,34.9.11h1A18.27,18.27,0,0,0,162.51,172.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.27,171.6h12.55a9.21,9.21,0,0,1,4.15,1l4,2s4,1,4.6,2.4-.12,2.32-1.62,2.44-26.95,0-26.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06,174.61h13.5a2.05,2.05,0,0,1,2.05,2h0a2.05,2.05,0,0,1-2.05,2.06h-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,174.58l-11.62,0-3.15-3h7.74a6,6,0,0,1,2.88.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34,174.63h0l-3.2-3.06h7.8a6.06,6.06,0,0,1,2.89.74l4.24,2.29H197Zm-3.08-3,3.1,3,11.52,0-4.07-2.2a6,6,0,0,0-2.87-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,178.72a8.34,8.34,0,0,1-1.48-1c-.9-.69-2.16-1.7-3.61-2.88l-.52-.43h.67l3.68,0c2.78,0,5.31,0,7.14,0a17.26,17.26,0,0,1,3,.17,15.22,15.22,0,0,1-3,.2c-1.83.05-4.36.09-7.14.1h-3.68l.16-.43c1.43,1.22,2.64,2.27,3.49,3A7.71,7.71,0,0,1,175,178.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19,178.41c0-.14,4.88-.26,10.89-.26s10.9.12,10.9.26-4.88.26-10.9.26S148.19,178.56,148.19,178.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.22,203.58h-10a7.33,7.33,0,0,0-3.31.79L371.71,206s-3.17.83-3.67,1.92.1,1.85,1.29,2,21.5,0,21.5,0Z",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.18,206H382.41a1.64,1.64,0,0,0-1.64,1.64h0a1.64,1.64,0,0,0,1.64,1.63h7.16Z",
    style: {
      fill: "#719AF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.71,206l9.27,0,2.51-2.41h-6.17a4.77,4.77,0,0,0-2.3.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.24,209.26A34.16,34.16,0,0,1,393,205.8l.16.43h-2.93c-2.23,0-4.24-.05-5.7-.1a10.33,10.33,0,0,1-2.36-.2,10.94,10.94,0,0,1,2.36-.17c1.46,0,3.47-.06,5.7-.05l2.93,0h.67l-.52.42A32.59,32.59,0,0,1,389.24,209.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63,209a71.25,71.25,0,0,1-8.69.26,71.35,71.35,0,0,1-8.7-.26,73.86,73.86,0,0,1,8.7-.26A73.75,73.75,0,0,1,410.63,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,207.27a50.64,50.64,0,0,1-10.25,0,50.64,50.64,0,0,1,10.25,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,276.17h10a7.46,7.46,0,0,1,3.31.78l3.2,1.6s3.16.82,3.66,1.91-.1,1.85-1.29,2-21.5,0-21.5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.07,278.57h10.77a1.64,1.64,0,0,1,1.64,1.64h0a1.63,1.63,0,0,1-1.64,1.64H95.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.55,278.55l-9.28,0-2.51-2.4h6.17a4.82,4.82,0,0,1,2.3.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26,278.6h0l-2.56-2.45h6.23a4.87,4.87,0,0,1,2.31.59l3.4,1.84h-.09Zm-2.44-2.4,2.46,2.35,9.17,0-3.23-1.74a4.81,4.81,0,0,0-2.29-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,281.85a33.86,33.86,0,0,1-4.09-3.09l-.52-.42h.67l2.94,0c2.22,0,4.24,0,5.69.06a10.94,10.94,0,0,1,2.36.17,10.78,10.78,0,0,1-2.36.19c-1.45.06-3.47.09-5.69.1H92.07l.16-.43A34.16,34.16,0,0,1,96,281.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.21,281.26a9.93,9.93,0,0,1-3.21.26,9.93,9.93,0,0,1-3.21-.26A10.27,10.27,0,0,1,87,281,10.27,10.27,0,0,1,90.21,281.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.33,280.21a7.88,7.88,0,0,1-2.85.26,7.84,7.84,0,0,1-2.85-.26,8.11,8.11,0,0,1,2.85-.26A8.15,8.15,0,0,1,92.33,280.21Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.5d6a840b794c9750bf1726b89d1c820e.svg";
export { ForwardRef as ReactComponent };